import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { addStateApi, updateStateApi } from "../../../services/state.service";
import { getCountryApi } from "../../../services/country.service";
import { useGetApi } from "../../../hooks/useGetApi";
import StateMasterSchema from "../../../joi/master/state-master-schema";
export default function StateModal({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) {
  const initialState = {
    stateName: "",
    country: "",
    active: true,
  };

  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((preValue) => ({
      ...preValue,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const { dataList: contryList } = useGetApi({
    apiFunction: getCountryApi,
    params: { limit: Number.MAX_SAFE_INTEGER },
    dataKey: "countries",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;

    const { error } = StateMasterSchema.validate({
      ...formData,
      country: formData?.country?._id,
    });

    if (error) {
      error.details.forEach((err) => toast.error(err.message));
      return;
    }

    setIsLoading(true);
    if (selectedRow?._id) {
      response = await updateStateApi({
        ...formData,
        country: formData?.country?._id,
      });
    } else {
      response = await addStateApi({
        ...formData,
        country: formData?.country?._id,
      });
    }
    setIsLoading(false);

    if (response?.code === 200 || response?.code === 201) {
      toast.success(
        response?.message ||
          `State ${selectedRow?._id ? "updated" : "added"} successfully`
      );
      setFormData(initialState);
      onClose();
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };
  useEffect(() => {
    if (selectedRow?._id) {
      setFormData({
        ...initialState,
        _id: selectedRow._id,
        stateName: selectedRow?.stateName || "",
        country: selectedRow?.country || "",

        active: selectedRow?.active ?? true,
      });
    } else {
      setFormData(initialState);
    }
  }, [open]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* Title */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Add State Master
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* form */}
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="State Name"
                name="stateName"
                value={formData?.stateName || ""}
                onChange={handleChange}
                fullWidth
                required
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={contryList || []}
                getOptionLabel={(option) => option?.countryName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"
                    name="country"
                    required
                    fullWidth
                  />
                )}
                value={formData?.country || null}
                onChange={(_, newValue) =>
                  handleChange({
                    target: { name: "country", value: newValue },
                  })
                }
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="active"
                    onChange={handleChange}
                    checked={formData?.active}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : selectedRow?._id ? (
                "Update"
              ) : (
                `Submit`
              )}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
